import { render, staticRenderFns } from "./v4ward-notice.vue?vue&type=template&id=8dd2482a&"
import script from "./v4ward-notice.vue?vue&type=script&lang=js&"
export * from "./v4ward-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports